<template>

</template>

<script>
import service from "../service";

export default {
  name: "Tracking",
  data() {
    return {

    };
  },
  methods: {

  },
  created() {
    let existingTrackingData = undefined;

    if (localStorage.trackingData) {
      existingTrackingData = JSON.parse(localStorage.trackingData);
    }

    if (!existingTrackingData) {
      existingTrackingData = {};
    }

    for (let key in this.$route.query) {
      existingTrackingData[key] = this.$route.query[key];
    }

    if (existingTrackingData) {
      localStorage.trackingData = JSON.stringify(existingTrackingData);
    
      service.sendTrackingData(existingTrackingData).then(() => {
          localStorage.trackingData = "";
        }
      );
    } else {
      
    }
  }
};
</script>